import { create } from "zustand"
import type { TAddColumnBasedCategoryModalStore, TColumnBasedModelNumbers } from "types/configuration.type"

export const createColumnBasedCategoryStore = create<TAddColumnBasedCategoryModalStore>((set) => ({
	category: {
		name: "",
		label: "",
		columns: [1, 2],
		superCategory: "",
		modelNumbers: {},
	},

	setFormValues: (newValues) =>
		set((state) => ({
			category: { ...state.category, ...newValues },
		})),

	updateColumnsRange: (newColumns) =>
		set((state) => {
			const [newStart, newEnd] = newColumns
			const [oldStart] = state.category.columns

			const newModelNumbers: TColumnBasedModelNumbers = {}

			for (let i = newStart; i <= newEnd; i++) {
				newModelNumbers[i.toString()] = []
			}

			if (Object.keys(state.category.modelNumbers).length > 0) {
				const offset = newStart - oldStart

				Object.entries(state.category.modelNumbers).forEach(([oldPosition, modelNumbers]) => {
					const oldPosNum = parseInt(oldPosition)
					const newPosNum = oldPosNum + offset
					const newPosition = newPosNum.toString()

					if (newPosNum >= newStart && newPosNum <= newEnd) {
						newModelNumbers[newPosition] = modelNumbers
					}
				})
			}

			return {
				category: {
					...state.category,
					columns: newColumns,
					modelNumbers: newModelNumbers,
				},
			}
		}),

	setColumnModelNumbers: (objectPosition: string, modelNumbers: number[]) =>
		set((state) => ({
			category: {
				...state.category,
				modelNumbers: {
					...state.category.modelNumbers,
					[objectPosition]: modelNumbers,
				},
			},
		})),

	resetForm: () =>
		set(() => ({
			category: {
				name: "",
				columns: [1, 2],
				label: "",
				superCategory: "",
				modelNumbers: {},
			},
		})),
}))
